module.exports = __webpack_public_path__ + "img/credit-card-logos.c06e22de.svg";